const state = () => ({
  apps: {
    items: [],
    paging: {
      navigator: {},
      options: {
        pageCount: 0,
        pageNumber: 0
      }
    },
    isLoading: true
  },
  detail: {
    additional_data: {
      type: '',
      required: [],
      properties: {}
    },
    classification: {},
    descriptions: [{ language: 'pt-br', shortDescription: '', fullDescription: '' }],
    banners: [],
    actions: [],
    events: [],
    optionalActions: [],
    optionalEvents: [],
    security: {
      hosts: []
    },
    isLoading: true,
    requestFailed: false
  },
  categories: [],
  events: [],
  actions: []
})

export default state
